import { APUserModeConfig } from '../../../global/components/user_mode_config/config/ap_user_mode_config';
import { APProgramDetailsQuery } from '../../../plan/queries/ap_program_details_query';
import { APAlternatePlanListQuery } from '../../queries/ap_alternate_plan_list_query';

class AlternatePlanLink {
  constructor(
    private $state: ng.ui.IStateService,
    private ngAPProgramDetailsQuery: APProgramDetailsQuery,
    private ngAPAlternatePlanListQuery: APAlternatePlanListQuery,
    private ngAPUserModeConfig: APUserModeConfig
  ) {}
  navigateToAlternatePlans() {
    const statePrefix = this.ngAPUserModeConfig.isAdvisor() ? 'ap-advisor' : 'my.planner';
    this.$state.go(`${statePrefix}.alternate-plans`);
  }
}
angular.module('capability-ng-academic-planner').component('alternatePlanLink', {
  templateUrl:
    'capability-ng-academic-planner/src/alternate_plans/components/alternate_plan_link/alternate_plan_link.html',
  controller: AlternatePlanLink
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/alternate_plans/components/alternate_plan_link/alternate_plan_link.ts